import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import App from './App';
import { TabInfoProvider } from './contexts/tab-info.context';
import { GlobalProvider } from './contexts/global.context';

import './index.scss';

// Create theme object to more easily style components
const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(12, 78, 12)',
    },
    secondary: {
      main: 'rgb(73, 150, 73)',
    },
    tertiary: {
      main: 'rgb(184, 223, 184)',
    },
  },
});

// Polyfill to allow react-markdown to work on Safari 15
if (!Object.hasOwn) {
  Object.hasOwn = (obj, prop) =>
    Object.prototype.hasOwnProperty.call(obj, prop);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <TabInfoProvider>
          <GlobalProvider>
            <Routes>
              <Route path='*' element={<App/>} />
            </Routes>
          </GlobalProvider>
        </TabInfoProvider>
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);
